import type { UUID } from '@hoedokloop/domain';
import { z } from '@hono/zod-openapi';

import type { CONTRACT_VERSION } from './versions';

export type RequestContext = {
  requestId: UUID;
  contractVersion: typeof CONTRACT_VERSION;
};

export const UUIDSchema = z.uuid().openapi({
  description: 'UUID; client-owned domain identifiers use UUIDv7',
  example: '0190f101-0000-7000-8000-000000000001',
});

export const InstantSchema = z.iso.datetime({ offset: true }).openapi({
  description: 'UTC or offset ISO-8601 instant',
  example: '2026-07-22T00:00:00.000Z',
});

export const LocalDateSchema = z
  .string()
  .regex(/^\d{4}-\d{2}-\d{2}$/)
  .refine((value) => {
    const [year, month, day] = value.split('-').map(Number);
    if (year === undefined || month === undefined || day === undefined) return false;
    const date = new Date(Date.UTC(year, month - 1, day));
    return (
      date.getUTCFullYear() === year &&
      date.getUTCMonth() === month - 1 &&
      date.getUTCDate() === day
    );
  }, 'Invalid calendar date')
  .openapi({ description: 'ISO calendar date without time or offset', example: '2026-07-22' });

export const Sha256Schema = z.string().regex(/^[a-f0-9]{64}$/i);
export const ChannelSchema = z.enum(['web', 'ait']);

export const RequestIdSchema = UUIDSchema.openapi('RequestId');
